// modules
import React, { FC } from 'react';
import { CloseIcon, Text, View } from '@upstox/upstox-ui';
import { observer } from 'mobx-react';
import LocaleService from 'modules/Localization';
// typings
import { DeleteAlertProps } from './typings';
// styles
import * as css from './styles';

const DeletePriceAlertsHeader: FC<DeleteAlertProps> = ({
  closeModal,
}) => (
  <View
    css={css.container}
  >
    <Text css={css.title}>
      {LocaleService.translate('DELETE_ALERT_MODAL_TITLE')}
    </Text>

    <CloseIcon css={css.closeIcon} onClick={closeModal} />
  </View>
);

export default observer(DeletePriceAlertsHeader);
